'use client';

import { FC, memo, PropsWithChildren, useEffect } from 'react';
import { getLocalStorage, setLocalStorage } from '@/common/localStorages';
import { useGetUser } from '@/queries/user';
import Toast from '@/components/Toast/Toast';
import EContractNotify from '@/modules/profile/pages/contracts/components/ContractItems/components/EContractNotify';

const EContractContainer: FC<PropsWithChildren<{}>> = ({ children }) => {
  const { data: user } = useGetUser();

  useEffect(() => {
    const isEContractNotified = getLocalStorage('EContract_notified') || false;

    if (!user || isEContractNotified) return;

    if (!user.hasEContractV2) {
      Toast.open({
        variant: 'info',
        duration: 5 * 1000,
        children: <EContractNotify />,
      });

      setLocalStorage('EContract_notified', true);
    }
  }, [user]);

  return <>{children}</>;
};

export default memo(EContractContainer);
